export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref10088.d113c319.jpg";